















































/* 共通 */
import { Component, Vue } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.07.19 [2023F-06] add
 */
@Component
export default class MailTemplateInfo extends ApiAccessBase {
   // 参照モードかどうか
  private updateAuthority: boolean = false;

  private created() {
    this.screenTitle = 'メールテンプレート編集';
    // 権限設定
    if (this.checkAuthority(AuthoritiesId.MST_UPDATE) || this.checkAuthority(AuthoritiesId.ROLE_CYDEEN2_ADMIN)) {
      this.updateAuthority = true;
    } else {
      this.updateAuthority = false;
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_template_info']);
    // APIアクセス
    this.apiAccess(KanriConstants.MAIL_PATH + '/init', Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        } else {
         this.updateAuthority = false;
        }
      },
    );
  }

  /**
   * テンプレート切替
   */
  private templateSwitch(value: string) {
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_template_info']);
    this.errorMessage = ''; //エラーメッセージリセット
    const path = KanriConstants.MAIL_PATH + '/init/switch' + '/' + value;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        this.hrefElement('mailTemplateInfo', -50);
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }

  /**
   * 貼付
   */
  private execInsertText() {
    for (const variablecol of Object.keys(this.variablecols)) {
      // 可変項目の使用有無判定
      if (this.variablecolsState[variablecol]) {
        for (const col of Object.keys(this.variablecols[variablecol])) {
          if (KanriConstants.REPLACE_STRING_NAME === this.variablecols[variablecol][col].name) {
            const element2 = document.getElementsByName(KanriConstants.MAIL_TEXT);
            element2[0].focus();
            document.execCommand('insertText', false, this.variablecols[variablecol][col].value);
          }
        }
      }
    }
  }

  /**
   * イメージ反映
   */
  private imageReflection() {
    this.apiAccess(KanriConstants.MAIL_PATH + '/init/image-reflection', Constants.API_METHOD_POST, true, true)
    .then((result) => {
      this.hrefElement('mailTemplateInfo', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        // メール本文イメージ反映
        const tempData : any = this.resultData;
        for (const variablecol of Object.keys(this.variablecols)) {
          if (this.variablecolsState[variablecol]) {
            for (const col of Object.keys(this.variablecols[variablecol])) {
              if (KanriConstants.MAIL_TEXT_IMAGE === this.variablecols[variablecol][col].name) {
                this.variablecols[variablecol][col].value = tempData.formData.mailTextImage;
              }
            }
          }
        }
      }
    });
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.IS_MODE_READ) {
      this.back();
    } else {
      if (window.confirm(Message.I0015)) {
        // 排他削除
        this.apiAccess(KanriConstants.MAIL_PATH + '/exclusive/delete', Constants.API_METHOD_POST, false, null)
        .then((result) => {
          if (result === Constants.API_RESULT_SUCCES) {
            this.back();
          }
        });
      }
    }
  }
  private back() {
    router.push({ name: 'kanri-top' });
  }

  /**
   * 登録
   */
  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    // 確認
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.apiAccess(KanriConstants.MAIL_PATH + '/update', Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('mailTemplateInfo', -50);
    });
  }
}
